import React from 'react';
import { Box } from '@mui/joy';
import { KPI } from 'src/mtska-frontend-app-component';
import JSONPretty from 'react-json-pretty'

const KPISetUnqualified = ({ dataProviderName }) => {

    const date = new Date();
    
    const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const formattedDateStartOfMonth = `${startOfMonth.getFullYear()}/${String(startOfMonth.getMonth() + 1).padStart(2, '0')}/${String(startOfMonth.getDate()).padStart(2, '0')}`;
    const formattedDateStartOfYear = `${startOfMonth.getFullYear()}/01/01`;

    // Eventualmente, recuperare i filtri del modulo da settings.filterModel
    // const { settings } = useSettingsContext(dataProviderName);

    return (
        <Box className="mtska-chart-wrapper">
            <KPI
                title="AdvertisingCosts"
                icon="faChartSimpleHorizontal"
                dataProviderName={'statisticsviews/item/count/advertisings/advertisingCost'}
            />
            <KPI
                title="AdvertisingCostsValue"
                icon="faCommentDollar"
                dataProviderName={'statisticsviews/item/sumfinancial/advertisings/advertisingCost/value'}
                format="currency"
                compactformat={false}
            />
            <KPI
                title={"Costs current year (" + formattedDateStartOfYear + ")"}
                icon="faCalendar"
                dataProviderName={'statisticsviews/item/sumfinancial/advertisings/advertisingCost/value'}
                format="currency"
                compactformat={false}
                filters={{
                    'items': [{
                        'field': 'registered_at',
                        'operator': 'afterOrEqual',
                        'value': formattedDateStartOfYear
                    }]
                }}
            />
            <KPI
                title={"Costs current month (" + formattedDateStartOfMonth + ")"}
                icon="faCalendar"
                dataProviderName={'statisticsviews/item/sumfinancial/advertisings/advertisingCost/value'}
                format="currency"
                compactformat={false}
                filters={{
                    'items': [{
                        'field': 'registered_at',
                        'operator': 'afterOrEqual',
                        'value': formattedDateStartOfMonth
                    }]
                }}
            />
        </Box>
    )
}

export default KPISetUnqualified;